document.querySelectorAll('footer .marquee').forEach((marquee) => {
	const gap = getComputedStyle(marquee).gap || '1.5rem';
	const speed = 50;

	const content = document.createElement('div');
	content.className = 'marquee-wrapper';
	content.style.display = 'inline-flex';
	content.style.alignItems = 'center';
	content.style.gap = gap;
	content.style.whiteSpace = 'nowrap';
	content.style.flex = '0 0 auto';

	while (marquee.firstChild) content.appendChild(marquee.firstChild);

	const track = document.createElement('div');
	track.className = 'marquee-track';
	track.style.display = 'inline-flex';
	track.style.alignItems = 'center';
	track.style.whiteSpace = 'nowrap';
	track.style.willChange = 'transform';
	track.style.transform = 'translate3d(0,0,0)';

	marquee.style.overflow = 'hidden';
	marquee.style.whiteSpace = 'nowrap';
	marquee.appendChild(track);

	let x = 0;
	let w = 0;
	let paused = false;
	let last = performance.now();

	function build() {
		track.innerHTML = '';
		track.appendChild(content);

		w = Math.ceil(content.scrollWidth);
		const view = Math.ceil(marquee.clientWidth);
		if (!w || !view) return;

		const minTotal = view + w + 50;
		let total = w;
		let n = 1;
		while (total < minTotal && n < 20) {
			track.appendChild(content.cloneNode(true));
			total += w;
			n++;
		}

		x = ((x % w) + w) % w;
		x = -x;
	}

	function tick(now) {
		const dt = Math.min(0.05, (now - last) / 1000);
		last = now;

		if (w && !paused) {
			x -= speed * dt;
			while (x <= -w) x += w;
			while (x > 0) x -= w;
			track.style.transform = `translate3d(${x}px,0,0)`;
		}

		requestAnimationFrame(tick);
	}

	build();

	let resizeRaf = 0;
	window.addEventListener('resize', () => {
		if (resizeRaf) cancelAnimationFrame(resizeRaf);
		resizeRaf = requestAnimationFrame(() => {
			resizeRaf = 0;
			build();
		});
	});

	if (window.ResizeObserver) {
		const ro = new ResizeObserver(() => build());
		ro.observe(marquee);
		ro.observe(content);
	}

	marquee.addEventListener('mouseenter', () => {
		paused = true;
	});
	marquee.addEventListener('mouseleave', () => {
		paused = false;
	});

	requestAnimationFrame(tick);
});
